import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/news',
    name: RouteName.News,
    component: () => import('@/pages/News/News'),
    meta: {
      breadcrumb: {
        label: 'Новости',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/news/create',
    name: 'Создать Новость',
    component: () => import('@/pages/News/NewsCreate'),
    meta: {
      breadcrumb: {
        label: 'Новая новость',
        parent: RouteName.News,
      },
    },
  },
  {
    path: '/news/:id',
    name: 'Новость',
    component: () => import('@/pages/News/NewsSingle'),
    meta: {
      breadcrumb: {
        label: 'Редактирование новости',
        parent: RouteName.News,
      },
    },
  },
]
